import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TagsComponent } from '@app/layout/tags/tags.component';
import { GallerySelectors } from '@app/store';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-gallery-tags',
  templateUrl: './gallery-tags.component.html',
  styleUrls: ['./gallery-tags.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TagsComponent],
})
export class GalleryTagsComponent {
  protected tags$: Observable<string[]> = inject(Store).select(
    GallerySelectors.tags,
  );
}
